// extracted by mini-css-extract-plugin
export default {"chartTitle":"Characteristics_chartTitle__Xc1-Q"};